/**
 * Компонент для ленивой загрузки изображений и видео
 */

'use client';

import { cloneElement, HTMLAttributes, memo, ReactElement, useEffect } from 'react';
import classNames from 'classnames';
import { videoLazyload } from '@/lazy-load';

interface Props extends HTMLAttributes<HTMLElement> {
    children: ReactElement;
}

const Lazy = ({ children, ...props }: Props) => {
    useEffect(() => {
        videoLazyload?.update();
    }, []);

    return cloneElement(children, {
        ...props,
        className: classNames(children.props.className, props.className, 'lazy'),
    });
};

export default memo(Lazy);
